
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useTextStreaming } from '@/hooks/useTextStreaming';
import { Button } from '@/components/ui/button';
import { SkipForward } from 'lucide-react';

interface StreamingTextProps {
  content: string;
  enableStreaming?: boolean;
  speed?: number;
  onStreamingComplete?: () => void;
  className?: string;
  hideSkipButton?: boolean; // Nova prop para esconder botão em documentos em branco
}

const StreamingText: React.FC<StreamingTextProps> = ({
  content,
  enableStreaming = true,
  speed = 15000, // ⚡ VELOCIDADE ULTRA-MÁXIMA por padrão: 15000 wpm
  onStreamingComplete,
  className = "",
  hideSkipButton = false // Padrão é mostrar o botão
}) => {
  const { displayedText, isStreaming, skipToEnd } = useTextStreaming({
    text: content,
    enabled: enableStreaming,
    speed,
    onComplete: onStreamingComplete
  });

  return (
    <div className={className}>
      <div className="prose prose-sm dark:prose-invert max-w-none break-words text-sm md:text-base">
        <ReactMarkdown>
          {displayedText}
        </ReactMarkdown>
      </div>
      {isStreaming && (
        <span className="inline-block w-2 h-4 bg-current animate-pulse ml-1" />
      )}
      
      {/* Só mostra o botão se não estiver escondido E estiver fazendo streaming */}
      {isStreaming && !hideSkipButton && (
        <div className="flex justify-end mt-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={skipToEnd}
            className="text-xs text-muted-foreground hover:text-foreground"
          >
            <SkipForward className="h-3 w-3 mr-1" />
            Pular animação
          </Button>
        </div>
      )}
    </div>
  );
};

export default StreamingText;
